import * as React from 'react';

export const ImportFromTextIcon = (
  <svg
    height="72"
    width="72"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 72 72"
  >
    <path
      fill="#E4FBFF"
      d="M16 9a2 2 0 0 1 2-2h28a4 4 0 0 1 4 4v34a6 6 0 0 1-6 6H20a4 4 0 0 1-4-4V9Z"
    />
    <path
      fill="#E4FBFF"
      d="M31 29a2 2 0 0 1 2-2h28a4 4 0 0 1 4 4v34a6 6 0 0 1-6 6H35a4 4 0 0 1-4-4V29Z"
    />
    <path
      fill="#0099C7"
      fillRule="evenodd"
      d="M25 37.5V62a5 5 0 0 0 5 5h26.002a5 5 0 0 0 5-5V27a5 5 0 0 0-5-5H41v2h15.002a3 3 0 0 1 3 3v35a3 3 0 0 1-3 3H30a3 3 0 0 1-3-3V37.5h-2Z"
      clipRule="evenodd"
    />
    <path
      fill="#0099C7"
      fillRule="evenodd"
      d="M46.002 17.976V6a5 5 0 0 0-5-5H15a5 5 0 0 0-5 5v35c0 2.32 1.58 4.27 3.721 4.835h7.614V44H15a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h26.002a3 3 0 0 1 3 3v11.976h2Z"
      clipRule="evenodd"
    />
    <rect width="22" height="2" x="17" y="11.5" fill="#0099C7" rx="1" />
    <rect
      width="22"
      height="2"
      x="54"
      y="60.5"
      fill="#0099C7"
      rx="1"
      transform="rotate(-180 54 60.5)"
    />
    <rect width="16" height="2" x="17" y="17.5" fill="#0099C7" rx="1" />
    <rect
      width="16"
      height="2"
      x="54"
      y="54.5"
      fill="#0099C7"
      rx="1"
      transform="rotate(-180 54 54.5)"
    />
    <path
      stroke="#0099C7"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M44.258 32.859v9.9h-9.9m9.37-.531L31.354 29.853"
    />
  </svg>
);
